/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoadingCapabilitiesAvailability } from './LoadingCapabilitiesAvailability';
import {
    LoadingCapabilitiesAvailabilityFromJSON,
    LoadingCapabilitiesAvailabilityFromJSONTyped,
    LoadingCapabilitiesAvailabilityToJSON,
    LoadingCapabilitiesAvailabilityToJSONTyped,
} from './LoadingCapabilitiesAvailability';
import type { Quote } from './Quote';
import {
    QuoteFromJSON,
    QuoteFromJSONTyped,
    QuoteToJSON,
    QuoteToJSONTyped,
} from './Quote';
import type { ShipmentState } from './ShipmentState';
import {
    ShipmentStateFromJSON,
    ShipmentStateFromJSONTyped,
    ShipmentStateToJSON,
    ShipmentStateToJSONTyped,
} from './ShipmentState';
import type { Broker } from './Broker';
import {
    BrokerFromJSON,
    BrokerFromJSONTyped,
    BrokerToJSON,
    BrokerToJSONTyped,
} from './Broker';
import type { StateOfGoods } from './StateOfGoods';
import {
    StateOfGoodsFromJSON,
    StateOfGoodsFromJSONTyped,
    StateOfGoodsToJSON,
    StateOfGoodsToJSONTyped,
} from './StateOfGoods';
import type { EmergencyContactDetails } from './EmergencyContactDetails';
import {
    EmergencyContactDetailsFromJSON,
    EmergencyContactDetailsFromJSONTyped,
    EmergencyContactDetailsToJSON,
    EmergencyContactDetailsToJSONTyped,
} from './EmergencyContactDetails';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { LineItem } from './LineItem';
import {
    LineItemFromJSON,
    LineItemFromJSONTyped,
    LineItemToJSON,
    LineItemToJSONTyped,
} from './LineItem';
import type { EquipmentType } from './EquipmentType';
import {
    EquipmentTypeFromJSON,
    EquipmentTypeFromJSONTyped,
    EquipmentTypeToJSON,
    EquipmentTypeToJSONTyped,
} from './EquipmentType';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface Shipment
 */
export interface Shipment {
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    shipmentId: string;
    /**
     * Whether the requesting user has starred this shipment (per-user).
     * @type {boolean}
     * @memberof Shipment
     */
    isStarred?: boolean;
    /**
     * The note the requesting user attached when starring this shipment (per-user); absent when not starred or no note was given.
     * @type {string}
     * @memberof Shipment
     */
    starReason?: string;
    /**
     * Checklist steps already ticked on this shipment, as the opaque "<list>/<item>" keys the client owns. Shared across the company's users. Sent with every shipment so a list can show progress without a round trip per row; the client decides what the keys mean, since the step list lives there and varies per shipment.
     * @type {Array<string>}
     * @memberof Shipment
     */
    checkedChecklistKeys?: Array<string>;
    /**
     * The subset of checkedChecklistKeys that were deliberately passed over rather than done. Optional steps only.
     * @type {Array<string>}
     * @memberof Shipment
     */
    skippedChecklistKeys?: Array<string>;
    /**
     * The customer told us something is wrong with this shipment. Theirs to raise and theirs to withdraw.
     * @type {boolean}
     * @memberof Shipment
     */
    customerFlagged?: boolean;
    /**
     * What the customer said is wrong, in their words.
     * @type {string}
     * @memberof Shipment
     */
    customerFlaggedMessage?: string;
    /**
     * Name of the person at the customer who raised the flag. Companies share an account, so this says which colleague.
     * @type {string}
     * @memberof Shipment
     */
    customerFlaggedByDisplayName?: string;
    /**
     * FreightSimple raised a problem on this shipment. Not the customer's to withdraw.
     * @type {boolean}
     * @memberof Shipment
     */
    operatorFlagged?: boolean;
    /**
     * What we told the customer is wrong. Written for them, not an internal note.
     * @type {string}
     * @memberof Shipment
     */
    operatorFlaggedMessage?: string;
    /**
     * Name of the FreightSimple operator who raised the flag.
     * @type {string}
     * @memberof Shipment
     */
    operatorFlaggedByDisplayName?: string;
    /**
     * The freight can't be located.
     * @type {boolean}
     * @memberof Shipment
     */
    freightMissing?: boolean;
    /**
     * Day the freight was recorded as missing.
     * @type {string}
     * @memberof Shipment
     */
    freightMissingDate?: string;
    /**
     * Fewer handling units arrived than were shipped.
     * @type {boolean}
     * @memberof Shipment
     */
    freightShortage?: boolean;
    /**
     * Day the shortage was recorded.
     * @type {string}
     * @memberof Shipment
     */
    freightShortageDate?: string;
    /**
     * The freight arrived damaged.
     * @type {boolean}
     * @memberof Shipment
     */
    freightDamaged?: boolean;
    /**
     * Day the damage was recorded.
     * @type {string}
     * @memberof Shipment
     */
    freightDamagedDate?: string;
    /**
     * 
     * @type {ShipmentState}
     * @memberof Shipment
     */
    shipmentState: ShipmentState;
    /**
     * 
     * @type {Quote}
     * @memberof Shipment
     */
    selectedQuote?: Quote;
    /**
     * 
     * @type {Array<LineItem>}
     * @memberof Shipment
     */
    lineItems: Array<LineItem>;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    pickupDate: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    pickupDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    deliveryDeadline?: string;
    /**
     * 
     * @type {EquipmentType}
     * @memberof Shipment
     */
    equipmentType?: EquipmentType;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    proNumber?: string;
    /**
     * 
     * @type {Location}
     * @memberof Shipment
     */
    pickupLocation: Location;
    /**
     * 
     * @type {Location}
     * @memberof Shipment
     */
    deliveryLocation: Location;
    /**
     * 
     * @type {Contact}
     * @memberof Shipment
     */
    pickupContact: Contact;
    /**
     * 
     * @type {Contact}
     * @memberof Shipment
     */
    deliveryContact: Contact;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    expectedDeliveryHours?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    actualDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    actualDeliveryTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    pickupReferenceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    deliveryReferenceNumber: string;
    /**
     * Amazon Reference ID, unpacked server-side from deliveryReferenceNumber. Only present when the delivery is to an Amazon distribution warehouse
     * @type {string}
     * @memberof Shipment
     */
    deliveryAmazonReferenceId?: string;
    /**
     * Amazon Shipment ID, unpacked server-side from deliveryReferenceNumber. Only present when the delivery is to an Amazon distribution warehouse
     * @type {string}
     * @memberof Shipment
     */
    deliveryAmazonShipmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    trId: string;
    /**
     * 
     * @type {Broker}
     * @memberof Shipment
     */
    broker?: Broker;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    bookedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Shipment
     */
    isReviewingPriorToBookingShipment: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Shipment
     */
    needsCustomsDocs: boolean;
    /**
     * 
     * @type {EmergencyContactDetails}
     * @memberof Shipment
     */
    emergencyContactDetails?: EmergencyContactDetails;
    /**
     * 
     * @type {Array<string>}
     * @memberof Shipment
     */
    finalizeBookingStages: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    bookedBy: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    latestedPredictedDeliveryDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Shipment
     */
    addInsuranceToShipment: boolean;
    /**
     * 
     * @type {number}
     * @memberof Shipment
     */
    insuranceAmount: number;
    /**
     * 
     * @type {Currency}
     * @memberof Shipment
     */
    insuranceCurrency: Currency;
    /**
     * 
     * @type {number}
     * @memberof Shipment
     */
    insurancePremiumAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    insurancePremiumCurrency?: string;
    /**
     * 
     * @type {number}
     * @memberof Shipment
     */
    insurancePremiumTaxesAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    insurancePremiumReferralReason?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    insuranceCommodityGroup?: string;
    /**
     * 
     * @type {StateOfGoods}
     * @memberof Shipment
     */
    stateOfGoods: StateOfGoods;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    appointmentDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    branchId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Shipment
     */
    exclusiveUseNeeded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Shipment
     */
    tarpRequired: boolean;
    /**
     * 
     * @type {number}
     * @memberof Shipment
     */
    linearFeet?: number;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    pickupBoothNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Shipment
     */
    deliveryBoothNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof Shipment
     */
    hasFreightClaims?: boolean;
    /**
     * Bill of lading number for tracking with carriers
     * @type {string}
     * @memberof Shipment
     */
    billOfLadingNumber?: string | null;
    /**
     * Per-company sequential number assigned when the shipment was booked (this company's 1st, 2nd, ... booked shipment). Gives customers a friendly 'Shipment #N' reference. Absent for shipments booked before numbering existed.
     * @type {number}
     * @memberof Shipment
     */
    bookedShipmentNumber?: number | null;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof Shipment
     */
    pickupLocationHasDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof Shipment
     */
    pickupLocationHasForklift?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof Shipment
     */
    deliveryLocationHasDock?: LoadingCapabilitiesAvailability;
    /**
     * 
     * @type {LoadingCapabilitiesAvailability}
     * @memberof Shipment
     */
    deliveryLocationHasForklift?: LoadingCapabilitiesAvailability;
}



/**
 * Check if a given object implements the Shipment interface.
 */
export function instanceOfShipment(value: object): value is Shipment {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('shipmentState' in value) || value['shipmentState'] === undefined) return false;
    if (!('lineItems' in value) || value['lineItems'] === undefined) return false;
    if (!('pickupDate' in value) || value['pickupDate'] === undefined) return false;
    if (!('pickupLocation' in value) || value['pickupLocation'] === undefined) return false;
    if (!('deliveryLocation' in value) || value['deliveryLocation'] === undefined) return false;
    if (!('pickupContact' in value) || value['pickupContact'] === undefined) return false;
    if (!('deliveryContact' in value) || value['deliveryContact'] === undefined) return false;
    if (!('pickupReferenceNumber' in value) || value['pickupReferenceNumber'] === undefined) return false;
    if (!('deliveryReferenceNumber' in value) || value['deliveryReferenceNumber'] === undefined) return false;
    if (!('trId' in value) || value['trId'] === undefined) return false;
    if (!('isReviewingPriorToBookingShipment' in value) || value['isReviewingPriorToBookingShipment'] === undefined) return false;
    if (!('needsCustomsDocs' in value) || value['needsCustomsDocs'] === undefined) return false;
    if (!('finalizeBookingStages' in value) || value['finalizeBookingStages'] === undefined) return false;
    if (!('bookedBy' in value) || value['bookedBy'] === undefined) return false;
    if (!('addInsuranceToShipment' in value) || value['addInsuranceToShipment'] === undefined) return false;
    if (!('insuranceAmount' in value) || value['insuranceAmount'] === undefined) return false;
    if (!('insuranceCurrency' in value) || value['insuranceCurrency'] === undefined) return false;
    if (!('stateOfGoods' in value) || value['stateOfGoods'] === undefined) return false;
    if (!('exclusiveUseNeeded' in value) || value['exclusiveUseNeeded'] === undefined) return false;
    if (!('tarpRequired' in value) || value['tarpRequired'] === undefined) return false;
    if (!('pickupBoothNumber' in value) || value['pickupBoothNumber'] === undefined) return false;
    if (!('deliveryBoothNumber' in value) || value['deliveryBoothNumber'] === undefined) return false;
    return true;
}

export function ShipmentFromJSON(json: any): Shipment {
    return ShipmentFromJSONTyped(json, false);
}

export function ShipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Shipment {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'isStarred': json['isStarred'] == null ? undefined : json['isStarred'],
        'starReason': json['starReason'] == null ? undefined : json['starReason'],
        'checkedChecklistKeys': json['checkedChecklistKeys'] == null ? undefined : json['checkedChecklistKeys'],
        'skippedChecklistKeys': json['skippedChecklistKeys'] == null ? undefined : json['skippedChecklistKeys'],
        'customerFlagged': json['customerFlagged'] == null ? undefined : json['customerFlagged'],
        'customerFlaggedMessage': json['customerFlaggedMessage'] == null ? undefined : json['customerFlaggedMessage'],
        'customerFlaggedByDisplayName': json['customerFlaggedByDisplayName'] == null ? undefined : json['customerFlaggedByDisplayName'],
        'operatorFlagged': json['operatorFlagged'] == null ? undefined : json['operatorFlagged'],
        'operatorFlaggedMessage': json['operatorFlaggedMessage'] == null ? undefined : json['operatorFlaggedMessage'],
        'operatorFlaggedByDisplayName': json['operatorFlaggedByDisplayName'] == null ? undefined : json['operatorFlaggedByDisplayName'],
        'freightMissing': json['freightMissing'] == null ? undefined : json['freightMissing'],
        'freightMissingDate': json['freightMissingDate'] == null ? undefined : json['freightMissingDate'],
        'freightShortage': json['freightShortage'] == null ? undefined : json['freightShortage'],
        'freightShortageDate': json['freightShortageDate'] == null ? undefined : json['freightShortageDate'],
        'freightDamaged': json['freightDamaged'] == null ? undefined : json['freightDamaged'],
        'freightDamagedDate': json['freightDamagedDate'] == null ? undefined : json['freightDamagedDate'],
        'shipmentState': ShipmentStateFromJSON(json['shipmentState']),
        'selectedQuote': json['selectedQuote'] == null ? undefined : QuoteFromJSON(json['selectedQuote']),
        'lineItems': ((json['lineItems'] as Array<any>).map(LineItemFromJSON)),
        'pickupDate': json['pickupDate'],
        'pickupDeadline': json['pickupDeadline'] == null ? undefined : json['pickupDeadline'],
        'deliveryDeadline': json['deliveryDeadline'] == null ? undefined : json['deliveryDeadline'],
        'equipmentType': json['equipmentType'] == null ? undefined : EquipmentTypeFromJSON(json['equipmentType']),
        'proNumber': json['proNumber'] == null ? undefined : json['proNumber'],
        'pickupLocation': LocationFromJSON(json['pickupLocation']),
        'deliveryLocation': LocationFromJSON(json['deliveryLocation']),
        'pickupContact': ContactFromJSON(json['pickupContact']),
        'deliveryContact': ContactFromJSON(json['deliveryContact']),
        'expectedDeliveryDate': json['expectedDeliveryDate'] == null ? undefined : json['expectedDeliveryDate'],
        'expectedDeliveryHours': json['expectedDeliveryHours'] == null ? undefined : json['expectedDeliveryHours'],
        'actualDeliveryDate': json['actualDeliveryDate'] == null ? undefined : json['actualDeliveryDate'],
        'actualDeliveryTime': json['actualDeliveryTime'] == null ? undefined : json['actualDeliveryTime'],
        'pickupReferenceNumber': json['pickupReferenceNumber'],
        'deliveryReferenceNumber': json['deliveryReferenceNumber'],
        'deliveryAmazonReferenceId': json['deliveryAmazonReferenceId'] == null ? undefined : json['deliveryAmazonReferenceId'],
        'deliveryAmazonShipmentId': json['deliveryAmazonShipmentId'] == null ? undefined : json['deliveryAmazonShipmentId'],
        'trId': json['trId'],
        'broker': json['broker'] == null ? undefined : BrokerFromJSON(json['broker']),
        'bookedAt': json['bookedAt'] == null ? undefined : json['bookedAt'],
        'isReviewingPriorToBookingShipment': json['isReviewingPriorToBookingShipment'],
        'needsCustomsDocs': json['needsCustomsDocs'],
        'emergencyContactDetails': json['emergencyContactDetails'] == null ? undefined : EmergencyContactDetailsFromJSON(json['emergencyContactDetails']),
        'finalizeBookingStages': json['finalizeBookingStages'],
        'bookedBy': json['bookedBy'],
        'latestedPredictedDeliveryDate': json['latestedPredictedDeliveryDate'] == null ? undefined : json['latestedPredictedDeliveryDate'],
        'addInsuranceToShipment': json['addInsuranceToShipment'],
        'insuranceAmount': json['insuranceAmount'],
        'insuranceCurrency': CurrencyFromJSON(json['insuranceCurrency']),
        'insurancePremiumAmount': json['insurancePremiumAmount'] == null ? undefined : json['insurancePremiumAmount'],
        'insurancePremiumCurrency': json['insurancePremiumCurrency'] == null ? undefined : json['insurancePremiumCurrency'],
        'insurancePremiumTaxesAmount': json['insurancePremiumTaxesAmount'] == null ? undefined : json['insurancePremiumTaxesAmount'],
        'insurancePremiumReferralReason': json['insurancePremiumReferralReason'] == null ? undefined : json['insurancePremiumReferralReason'],
        'insuranceCommodityGroup': json['insuranceCommodityGroup'] == null ? undefined : json['insuranceCommodityGroup'],
        'stateOfGoods': StateOfGoodsFromJSON(json['stateOfGoods']),
        'appointmentDate': json['appointmentDate'] == null ? undefined : json['appointmentDate'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'exclusiveUseNeeded': json['exclusiveUseNeeded'],
        'tarpRequired': json['tarpRequired'],
        'linearFeet': json['linearFeet'] == null ? undefined : json['linearFeet'],
        'pickupBoothNumber': json['pickupBoothNumber'],
        'deliveryBoothNumber': json['deliveryBoothNumber'],
        'hasFreightClaims': json['hasFreightClaims'] == null ? undefined : json['hasFreightClaims'],
        'billOfLadingNumber': json['billOfLadingNumber'] == null ? undefined : json['billOfLadingNumber'],
        'bookedShipmentNumber': json['bookedShipmentNumber'] == null ? undefined : json['bookedShipmentNumber'],
        'pickupLocationHasDock': json['pickupLocationHasDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasDock']),
        'pickupLocationHasForklift': json['pickupLocationHasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['pickupLocationHasForklift']),
        'deliveryLocationHasDock': json['deliveryLocationHasDock'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': json['deliveryLocationHasForklift'] == null ? undefined : LoadingCapabilitiesAvailabilityFromJSON(json['deliveryLocationHasForklift']),
    };
}

  export function ShipmentToJSON(json: any): Shipment {
      return ShipmentToJSONTyped(json, false);
  }

  export function ShipmentToJSONTyped(value?: Shipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'isStarred': value['isStarred'],
        'starReason': value['starReason'],
        'checkedChecklistKeys': value['checkedChecklistKeys'],
        'skippedChecklistKeys': value['skippedChecklistKeys'],
        'customerFlagged': value['customerFlagged'],
        'customerFlaggedMessage': value['customerFlaggedMessage'],
        'customerFlaggedByDisplayName': value['customerFlaggedByDisplayName'],
        'operatorFlagged': value['operatorFlagged'],
        'operatorFlaggedMessage': value['operatorFlaggedMessage'],
        'operatorFlaggedByDisplayName': value['operatorFlaggedByDisplayName'],
        'freightMissing': value['freightMissing'],
        'freightMissingDate': value['freightMissingDate'],
        'freightShortage': value['freightShortage'],
        'freightShortageDate': value['freightShortageDate'],
        'freightDamaged': value['freightDamaged'],
        'freightDamagedDate': value['freightDamagedDate'],
        'shipmentState': ShipmentStateToJSON(value['shipmentState']),
        'selectedQuote': QuoteToJSON(value['selectedQuote']),
        'lineItems': ((value['lineItems'] as Array<any>).map(LineItemToJSON)),
        'pickupDate': value['pickupDate'],
        'pickupDeadline': value['pickupDeadline'],
        'deliveryDeadline': value['deliveryDeadline'],
        'equipmentType': EquipmentTypeToJSON(value['equipmentType']),
        'proNumber': value['proNumber'],
        'pickupLocation': LocationToJSON(value['pickupLocation']),
        'deliveryLocation': LocationToJSON(value['deliveryLocation']),
        'pickupContact': ContactToJSON(value['pickupContact']),
        'deliveryContact': ContactToJSON(value['deliveryContact']),
        'expectedDeliveryDate': value['expectedDeliveryDate'],
        'expectedDeliveryHours': value['expectedDeliveryHours'],
        'actualDeliveryDate': value['actualDeliveryDate'],
        'actualDeliveryTime': value['actualDeliveryTime'],
        'pickupReferenceNumber': value['pickupReferenceNumber'],
        'deliveryReferenceNumber': value['deliveryReferenceNumber'],
        'deliveryAmazonReferenceId': value['deliveryAmazonReferenceId'],
        'deliveryAmazonShipmentId': value['deliveryAmazonShipmentId'],
        'trId': value['trId'],
        'broker': BrokerToJSON(value['broker']),
        'bookedAt': value['bookedAt'],
        'isReviewingPriorToBookingShipment': value['isReviewingPriorToBookingShipment'],
        'needsCustomsDocs': value['needsCustomsDocs'],
        'emergencyContactDetails': EmergencyContactDetailsToJSON(value['emergencyContactDetails']),
        'finalizeBookingStages': value['finalizeBookingStages'],
        'bookedBy': value['bookedBy'],
        'latestedPredictedDeliveryDate': value['latestedPredictedDeliveryDate'],
        'addInsuranceToShipment': value['addInsuranceToShipment'],
        'insuranceAmount': value['insuranceAmount'],
        'insuranceCurrency': CurrencyToJSON(value['insuranceCurrency']),
        'insurancePremiumAmount': value['insurancePremiumAmount'],
        'insurancePremiumCurrency': value['insurancePremiumCurrency'],
        'insurancePremiumTaxesAmount': value['insurancePremiumTaxesAmount'],
        'insurancePremiumReferralReason': value['insurancePremiumReferralReason'],
        'insuranceCommodityGroup': value['insuranceCommodityGroup'],
        'stateOfGoods': StateOfGoodsToJSON(value['stateOfGoods']),
        'appointmentDate': value['appointmentDate'],
        'branchId': value['branchId'],
        'exclusiveUseNeeded': value['exclusiveUseNeeded'],
        'tarpRequired': value['tarpRequired'],
        'linearFeet': value['linearFeet'],
        'pickupBoothNumber': value['pickupBoothNumber'],
        'deliveryBoothNumber': value['deliveryBoothNumber'],
        'hasFreightClaims': value['hasFreightClaims'],
        'billOfLadingNumber': value['billOfLadingNumber'],
        'bookedShipmentNumber': value['bookedShipmentNumber'],
        'pickupLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasDock']),
        'pickupLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['pickupLocationHasForklift']),
        'deliveryLocationHasDock': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasDock']),
        'deliveryLocationHasForklift': LoadingCapabilitiesAvailabilityToJSON(value['deliveryLocationHasForklift']),
    };
}

